
import urlParts from '../constants/apiUrls';
import { buildBackUrl } from './buildBackUrl';

export function getProviderProducts(code) {
  const url = buildBackUrl(urlParts.products);
  url.searchParams.set('providerCode', code);

  return fetch(url, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      return Promise.reject(`Error in getProductsByProvider: ${err}`);
    });
}
